var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcAll = function SvgIcAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .5a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6ZM3.3 7.4a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm2.7 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Zm2.7 0a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Z"
  })));
};
export default SvgIcAll;